module.exports = {};


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = 1